<template>
  <div id="app">
    <div v-if="!adesaoFinalizada" id="header">
      <header-alianca />
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  computed: {
    adesaoFinalizada() {
      return this.$route.name === 'adesao-finalizada';
    },
  },
};
</script>
<style lang="scss">
@import url("./assets/styles.css");
</style>
